var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_32822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5357 2.23341C17.5219 2.17014 17.4916 2.11167 17.4478 2.06395C17.4041 2.01623 17.3484 1.98098 17.2866 1.9618C17.0615 1.9174 16.8286 1.93405 16.6121 2.01001C16.6121 2.01001 1.5923 7.40841 0.734626 8.00626C0.549269 8.13484 0.487661 8.2093 0.457126 8.29769C0.308733 8.72305 0.770519 8.91055 0.770519 8.91055L4.64159 10.1722C4.70698 10.1835 4.7741 10.1794 4.83766 10.1604C5.71838 9.6043 13.6978 4.56537 14.1591 4.39609C14.2314 4.37412 14.285 4.39609 14.2732 4.44966C14.0846 5.09573 7.19373 11.2195 7.1557 11.257C7.13721 11.2721 7.12268 11.2916 7.11335 11.3136C7.10402 11.3356 7.10016 11.3596 7.10213 11.3834L6.74213 15.1607C6.74213 15.1607 6.59105 16.3393 7.76748 15.1607C8.60159 14.3255 9.40195 13.6345 9.8032 13.2986C11.1344 14.2173 12.5669 15.2336 13.1846 15.7629C13.2883 15.8635 13.4111 15.9423 13.5459 15.9944C13.6806 16.0465 13.8245 16.0709 13.9689 16.0661C14.5582 16.0436 14.7189 15.3991 14.7189 15.3991C14.7189 15.3991 17.4553 4.38751 17.5475 2.91162C17.5561 2.76698 17.5684 2.6743 17.5694 2.57519C17.5743 2.46024 17.563 2.34518 17.5357 2.23341Z",
    fill: "#757185"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_32822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(0.427734 0.428711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.06dc8cc1e29f73412991211ac0247563.svg";
export { ForwardRef as ReactComponent };